import { render, staticRenderFns } from "./IssueLine.vue?vue&type=template&id=344b8612&scoped=true&"
import script from "./IssueLine.vue?vue&type=script&lang=js&"
export * from "./IssueLine.vue?vue&type=script&lang=js&"
import style0 from "./IssueLine.vue?vue&type=style&index=0&id=344b8612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344b8612",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VLayout})
